<template>
  <div class="model-count" id="modelCount">
    <Chart
      v-if="!isFirstLoad && !error && !isNoData"
      :options="chartOptions"
    />
    <div v-else-if="isFirstLoad" class="sk-three-bounce">
      <div class="sk-child sk-bounce1"></div>
      <div class="sk-child sk-bounce2"></div>
      <div class="sk-child sk-bounce3"></div>
    </div>
    <NoData v-else-if="isNoData"/>
    <ChartError v-else class="error-container"></ChartError>
  </div>
</template>

<script>
  import {mapActions, mapGetters, mapState} from "vuex";
  import {Chart} from "highcharts-vue";
  import {HIGHCHARTS_DEFAULTS} from "../../constants";
  import ChartError from "../errors/ChartError";
  import NoData from "../errors/NoData";

  export default {
    name: "ModelCount",
    components: {
      Chart,
      ChartError,
      NoData
    },
    props: ['sitecode', 'loading', 'error', 'lastUpdatedAt'],
    methods: {
      ...mapActions(['fetchModelCountForChart', 'setFilter'])
    },
    mounted() {
      this.fetchModelCountForChart({sitecode: this.sitecode});
    },
    watch: {
      filters: {
        handler: function () {
          this.fetchModelCountForChart({sitecode: this.sitecode});
        },
        deep: true,
      },
      sitecode: function (value) {
        this.fetchModelCountForChart({sitecode: value});
      },
    },
    computed: {
      ...mapGetters(['deviceCountByModelSeries']),
      ...mapState({filters: state => state.api.filters}),
      isFirstLoad() {
        return this.loading && this.lastUpdatedAt == null;
      },
      isNoData() {
        const data = this.deviceCountByModelSeries;
        if (Array.isArray(data) && data.length > 0) {
          return false;
        }
        return true;
      },
      chartOptions: function () {
        return Object.assign({}, HIGHCHARTS_DEFAULTS, {
          colors: [
            "#041E42",
          ],
          chart: {
            type: "bar",
            events: {},
            marginLeft: 200,
          },
          title: {
            text: "Top 10 Model Count",
            style: {
              color: '#041E42',
            },
            y: 22,
            x: 15,
          },
          xAxis: {
            type: "category",
            min: 0,
            max: 9,
            scrollbar: {
              enabled: true
            },
            labels: {
              style: {
                width: '160px',
                // useHTML: true,
                // 'min-width': '160px',
                // whiteSpace: 'nowrap',
                // textOverflow: 'ellipsis'
              },
              formatter: function () {
                const chartSeries = this.axis.series ? this.axis.series[0] : null;
                if (chartSeries) {
                  const position = this.pos;
                  const yData = chartSeries.yData ? chartSeries.yData[position] : null;
                  if (yData) {
                    return this.value + ' <b>(' + yData + ')</b>';
                  }
                }
                return this.value;
              }
            }
          },
          yAxis: {
            title: {
              text: "Number of Devices",
              margin: 20
            }
          },
          legend: {
            enabled: false
          },
          series: [
            {
              name: "Number of devices",
              data: this.deviceCountByModelSeries,
              maxPointHeight: 50
            }
          ],
          plotOptions: {
            bar: {}
          },
          navigation: {
            buttonOptions: {
              y: 8
            }
          },
        });
      }
    },
  };
</script>

<style scoped>
  #modelCount  >>> .highcharts-series rect.highcharts-point.highcharts-drilldown-point {
    width: 12px;
  }

  #modelCount >>> .highcharts-drillup-button {
    display: none !important;
  }

  #modelCount >>> .highcharts-xaxis-labels text {
    text-decoration: none !important;
    color: #121212 !important;
    fill: #121212 !important;
    font-weight: normal !important;
  }
</style>
